import React from 'react';
import { ClockIcon } from 'lucide-react';
const Header = () => {
  return <div className="w-full bg-[#FF6B3C] text-white py-2 text-center text-lg md:text-xl font-medium flex items-center justify-center" data-id="element-181">
      <ClockIcon className="w-4 h-4 mr-2" data-id="element-182" />
      <span data-id="element-183">
        ¡Cientos de mamás ya lo usan! Accede hoy por menos de lo que cuesta un
        café ☕ Oferta por tiempo limitado.
      </span>
    </div>;
};
export default Header;